/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalReauthReportGeneration } from './PalReauthReportGeneration';
import {
    PalReauthReportGenerationFromJSON,
    PalReauthReportGenerationFromJSONTyped,
    PalReauthReportGenerationToJSON,
} from './PalReauthReportGeneration';

/**
 * 
 * @export
 * @interface CreatePalReauthReportGeneration201Response
 */
export interface CreatePalReauthReportGeneration201Response {
    /**
     * 
     * @type {PalReauthReportGeneration}
     * @memberof CreatePalReauthReportGeneration201Response
     */
    data?: PalReauthReportGeneration;
}

/**
 * Check if a given object implements the CreatePalReauthReportGeneration201Response interface.
 */
export function instanceOfCreatePalReauthReportGeneration201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreatePalReauthReportGeneration201ResponseFromJSON(json: any): CreatePalReauthReportGeneration201Response {
    return CreatePalReauthReportGeneration201ResponseFromJSONTyped(json, false);
}

export function CreatePalReauthReportGeneration201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePalReauthReportGeneration201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PalReauthReportGenerationFromJSON(json['data']),
    };
}

export function CreatePalReauthReportGeneration201ResponseToJSON(value?: CreatePalReauthReportGeneration201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PalReauthReportGenerationToJSON(value.data),
    };
}

